import React from 'react';
import { Box} from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";
import Typography from '@mui/material/Typography';
import CommunityImg from '../../../assets/svgs/community.png';
import {communityimage2} from '~/assets'
import { line } from '~/assets';
import Button from '@mui/material/Button';
import { communityMobile } from '~/assets';
import { RightArrow } from '~/assets';

const useStyles = makeStyles((theme) => ({
  
  desktop:{
    display:'none',
    [theme.breakpoints.up('lg')]:{
      display: 'block',
      width:'100%',
      
    },
  },

  mobile: {
    [theme.breakpoints.up('lg')]:{
      display: 'none'
    },
  }
    
}));

export const CommunityPage = () => {
  const classes = useStyles();
  return (
    <Box
      marginX={{ xs: 2, lg: 10, xl:0 }}
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      marginTop={{ xs: 5, lg: 10 }}
      maxWidth="1440px"
      width="100%"
    >
      <Box>
        <Typography variant="h5"
        style={{
          backgroundColor:"#F69501",
          backgroundImage: 'linear-gradient(268.99deg, #F69501 0.03%, #F1756E 100.53%)',
          WebkitTextFillColor:'transparent',
          backgroundClip:'text',
          WebkitBackgroundClip:'text'
        }}
        fontSize={{xs:'12px', md:'16px'}}
        lineHeight={{xs:'18px', md:'26px'}}
        letterSpacing='0.2rem'
        > 
          STAKEHOLDERS IN DLA
        </Typography>
      </Box>

      <Box>
        <Typography
          variant='h6'
          fontSize={{xs:'24px', lg:'40px'}}
          mt={2}
          align="center"
        >
          Be a part of our community<br></br> & find your place in our ecosystem!
        </Typography>
      </Box>

      <Box>
        <img className={classes.mobile} style={{marginTop:'30px', marginBottom:'30px'}} width='100%' src={communityMobile}></img>
        <img className={classes.desktop} width="100%" src={communityimage2} />
      </Box>
      <a style={{textDecoration:"none"}} href="https://discord.gg/nPpV56Rsg4 ">
      <Button
              variant="contained"
              sx={{
                // height: 144,
                paddingX: 3,
                paddingY: 1,
                // width:42
                backgroundColor: '#fff',
                color: '#000',
                textDecoration:'none'
                // margin: "5px 10px 5px 90px",
                // padding: '5px',
              }}
            >
              <Typography
              // font-family: Poppins;
              // font-size: 13px;
              // font-weight: 500;
              // line-height: 24px;
              // letter-spacing: 0.295em;
              // text-align: left;
              style={{
                fontFamily: 'Poppins',
                fontSize: '13px',
                fontWeight: 500,
                lineHeight: "24px",
                letterSpacing: "0.295em",
                textDecoration: "none",
                color: '#000000'
              }}             
              >
                JOIN OUR DISCORD
              </Typography>
              <Box
                    // bgcolor="red"
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    marginLeft={2}
                  >
                    <img src={RightArrow}></img>
              </Box>
      </Button>
      </a>
      <Box className={classes.desktop} marginTop={10}>
          <img src={line} width="100%" height="100%"/>
      </Box>
    </Box>
  );
};
